
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/who-we-are",
      function () {
        return require("private-next-pages/who-we-are.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/who-we-are"])
      });
    }
  